// Принтер с выезжающим листом — увеличенная версия .printer-mini из макета (экран 8).
// Раньше здесь была гифка на 60vw; вектор чётче на киоск-экране и не тянет лишний ассет.
function PrinterAnimation() {
    // Пропорция корпуса ~1.16:1, как в макете. Ширина задана в vw, а не в vh:
    // на портретном экране киоска vh-ширина вылезала за края карточки.
    return (
        <div className="relative mx-auto w-[58vw] h-[28vh]">
            {/* лоток выдачи: лист выезжает из-под корпуса, поэтому он ниже по z */}
            <div
                className="absolute left-[14%] right-[14%] top-[62%] h-[26%] bg-white border-[0.3vh] border-[#E1E4EB] border-t-0 rounded-b-[1vh] z-[1]"
                style={{ animation: "sheetFeed 2.6s ease-in-out infinite" }}
            />
            {/* корпус */}
            <div className="absolute left-0 right-0 top-[22%] h-[40%] bg-[#12161F] rounded-[2vh] z-[3]" />
            {/* щель выдачи */}
            <div className="absolute left-[12%] right-[12%] top-[59%] h-[1.4vh] bg-[#080B10] rounded-b-[0.8vh] z-[3]" />
            {/* подающий лоток сверху */}
            <div className="absolute left-[22%] right-[22%] top-[6%] h-[16%] bg-[#E1E4EB] rounded-t-[1.2vh] z-[2]" />
            {/* индикатор работы на корпусе */}
            <div
                className="absolute left-[8%] top-[32%] w-[1.6vh] h-[1.6vh] rounded-full bg-[#246CE2] z-[4]"
                style={{ animation: "pulse 1.4s ease-in-out infinite" }}
            />
        </div>
    );
}

export default PrinterAnimation;
